import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => {
      // window / document
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // common root selectors
      const selectors = [
        "#root",
        "#app",
        ".main",
        ".content",
        ".app-content",
        ".layout-content",
      ];
      selectors.forEach((sel) => {
        const el = document.querySelector(sel);
        if (el) {
          if (typeof el.scrollTo === "function")
            el.scrollTo({ top: 0, left: 0, behavior: "auto" });
          else el.scrollTop = 0;
        }
      });

      // detect and reset any other scrollable containers
      try {
        const all = Array.from(document.querySelectorAll("*"));
        const scrollables = all.filter((el) => {
          const style = window.getComputedStyle(el);
          const ov = style.overflowY;
          return (
            el.scrollHeight > el.clientHeight &&
            (ov === "auto" || ov === "scroll" || ov === "overlay")
          );
        });
        scrollables.forEach((el) => {
          if (typeof el.scrollTo === "function")
            el.scrollTo({ top: 0, left: 0, behavior: "auto" });
          else el.scrollTop = 0;
        });
      } catch (e) {
        /* ignore */
      }
    }, 0);
  }, [pathname]);
  return null;
}
